import React from 'react'
import ReactDom from 'react-dom'


/**
 *
 */
export const init = () => {
  initPosSection()
  initInvoiceCreationSection()
  initPaymentSection()
  initCatalogSection()
  initDashboardSection()
  initMarketSection()
}

/**
 *
 */
const initPosSection = () => {
  $('.pos-option').on({
    mouseenter: function()
    {
      $('.pos-option').removeClass('active')
      $(this).addClass('active')
      if ($(this).hasClass('pos-option-1')) {
        $('.pos-option-detail .subtitle').html('Vende desde la aplicación web')
        $('.pos-viewer').alterClass('pos-viewer-*', 'pos-viewer-web')
      } else if ($(this).hasClass('pos-option-2')) {
        $('.pos-option-detail .subtitle').html('Vende desde la aplicación móvil')
        $('.pos-viewer').alterClass('pos-viewer-*', 'pos-viewer-mobile')
      }
    }
  })
  ReactDom.render(<PosViewer/>, $('.pos-option-images')[0])
}

/**
 *
 */
const initInvoiceCreationSection = () => {
  $('.invoice-creation-step').on(
    {
      mouseenter: function()
      {
        $('.invoice-creation-step').removeClass('active')
        $(this).addClass('active')
        if ($(this).hasClass('step-1')) {
          $('.invoice-creation-image').alterClass('step-*', 'step-1')
        } else if ($(this).hasClass('step-2')) {
          $('.invoice-creation-image').alterClass('step-*', 'step-2')
        } else if ($(this).hasClass('step-3')) {
          $('.invoice-creation-image').alterClass('step-*', 'step-3')
        }
      }
    })
}

/**
 *
 */
const initPaymentSection = () => {
  $('.payment-feature').on(
    {
      mouseenter: function()
      {
        $('.payment-feature').removeClass('active')
        $(this).addClass('active')
        if ($(this).hasClass('feature-1')) {
          $('.payment-features-image').alterClass('feature-*', 'feature-1')
        } else if ($(this).hasClass('feature-2')) {
          $('.payment-features-image').alterClass('feature-*', 'feature-2')
        }
      }
    })
}

/**
 *
 */
const initCatalogSection = () => {
  $('.catalog-feature').on(
    {
      mouseenter: function()
      {
        $('.catalog-feature').removeClass('active')
        $(this).addClass('active')
        if ($(this).hasClass('feature-1')) {
          $('.catalog-features-image').alterClass('feature-*', 'feature-1')
        } else if ($(this).hasClass('feature-2')) {
          $('.catalog-features-image').alterClass('feature-*', 'feature-2')
        } else if ($(this).hasClass('feature-3')) {
          $('.catalog-features-image').alterClass('feature-*', 'feature-3')
        }
      }
    })
}

/**
 *
 */
const initDashboardSection = () => {
  $('.dashboard-feature').on(
    {
      mouseenter: function()
      {
        $('.dashboard-feature').removeClass('active')
        $(this).addClass('active')
        if ($(this).hasClass('feature-1')) {
          $('.dashboard-features-image').alterClass('feature-*', 'feature-1')
        } else if ($(this).hasClass('feature-2')) {
          $('.dashboard-features-image').alterClass('feature-*', 'feature-2')
        } else if ($(this).hasClass('feature-3')) {
          $('.dashboard-features-image').alterClass('feature-*', 'feature-3')
        }
      }
    })
}

const initMarketSection = () => {
  $('.market-feature').on(
    {
      mouseenter: function()
      {
        $('.market-feature').removeClass('active')
        $(this).addClass('active')
        if ($(this).hasClass('feature-1')) {
          $('.market-features-image').alterClass('feature-*', 'feature-1')
        } else if ($(this).hasClass('feature-2')) {
          $('.market-features-image').alterClass('feature-*', 'feature-2')
        } else if ($(this).hasClass('feature-3')) {
          $('.market-features-image').alterClass('feature-*', 'feature-3')
        }
      },
    })
}


/**
 *
 */
const PosViewer = React.createClass({
  getInitialState() {
    return {
      currentImage: 1
    }
  },
  onDotClick(evt) {
    this.setState({ currentImage: parseInt($(evt.target).attr('id')) })
  },
  onLeftArrowClick() {
    let currentImage = this.state.currentImage - 1
    if (currentImage < 1) {
      currentImage = 3
    }
    this.setState({ currentImage: currentImage })
  },
  onRightArrowClick() {
    let currentImage = this.state.currentImage + 1
    if (currentImage > 3) {
      currentImage = 1
    }
    this.setState({ currentImage: currentImage })
  },
  render() {
    return (
      <div className='container'>
        <div className='pos-viewer pos-viewer-web'>
          <div className='pos-viewer-arrow-container'>
            <span
              onClick={this.onLeftArrowClick}
              className='pos-viewer-arrow pos-viewer-arrow-left'>
            </span>
          </div>
          <div className='pos-viewer-image-container'>
            <div className={'pos-viewer-image pos-viewer-image-' + this.state.currentImage}></div>
          </div>
          <div className='pos-viewer-arrow-container'>
            <span
              onClick={this.onRightArrowClick}
              className='pos-viewer-arrow pos-viewer-arrow-right'>
            </span>
          </div>
        </div>
        <div className='row pos-viewer-dots'>
          <ul>
            <li id='1'
                onClick={this.onDotClick}
                className={ this.state.currentImage == 1 ? 'active' : '' }/>
            <li id='2'
                onClick={this.onDotClick}
                className={ this.state.currentImage == 2 ? 'active' : '' }/>
            <li id='3'
                onClick={this.onDotClick}
                className={ this.state.currentImage == 3 ? 'active' : '' }/>
          </ul>
        </div>
        <div className='pos-viewer-responsive-arrow-container'>
          <span
            onClick={this.onLeftArrowClick}
            className='pos-viewer-arrow pos-viewer-arrow-left'/>
          <span
            onClick={this.onRightArrowClick}
            className='pos-viewer-arrow pos-viewer-arrow-right'/>
        </div>
      </div>
    )
  }
})
